function ArgosTraderBotButton() {
    return (
        <button
            id="btnArgosTraderBot"
            className="btn btn-primary animate-up-2 me-2"
            data-bs-toggle="modal"
            data-bs-target="#modalArgosTraderBot"
        >
            <img
                src="/img/favicon/favicon-32x32.png"
                height="20"
                width="32"
                alt="Argos TraderBot Logo"
            />
        </button>
    );
}

export default ArgosTraderBotButton;
